import React from "react";
import { ErrorMessage, FormField, InfoIcon } from "@vwfs-bronson/bronson-react";
import { getIn } from "formik/dist/index";
import MaskedInput from 'react-text-mask';

function normalizeDate(value) {
  if (!value) return value;
  // it is already in the proper format
  if (value.indexOf(".") !== -1) return value;

  return value.split("-").reverse().join(".");
}

export function DateField({
  field: { onChange, value, onBlur, name },
  form: { errors, touched },
  label,
  tooltip,
  notion,
  ...props
}) {
  const id = props.id || name;
  const error = getIn(touched, name) && getIn(errors, name);

  const createDateMask = (raw) => {
    return [/[\d]/, /[\d]/, '.', /[\d]/, /[\d]/, '.', /[\d]/, /[\d]/, /[\d]/, /[\d]/,]
  };

  return (
    <FormField
      labelElement="div"
      type="input"
      labelText={label}
      id={id}
      infoIcon={tooltip && <InfoIcon icon="semantic-info">{tooltip}</InfoIcon>}
      notion={notion}
      noFloatingLabel
      errorMessage={error ? <ErrorMessage id={id}>{error}</ErrorMessage> : null}
    >
      <MaskedInput
        {...props}
        name={name}
        value={normalizeDate(value)}
        className={`c-input__input ${error ? 'is-error': ''}`}
        placeholder="TT.MM.JJJJ"
        guide={false}
        mask={createDateMask}
        onChange={(event) => {
          onChange({
            target: {
              name,
              value: event.target.value.split(".").reverse().join("-"),
            },
          });
        }}
        onBlur={(event) => {
          const value = event.target.value
          onChange({
            target: {
              name,
              value: value.split(".").reverse().join("-"),
            },
          });
          onBlur(value);
        }}
      />

    </FormField>
  );
}
